import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShareddtaService {

  private dataSubject = new Subject<any>();
  data$ = this.dataSubject.asObservable();
  private refreshdataSubject = new Subject<any>();
  refreshdata$ = this.refreshdataSubject.asObservable();
  private refreshdataSubject1 = new Subject<any>();
  refreshdata1$ = this.refreshdataSubject1.asObservable();

  private countryCodeSubject = new BehaviorSubject<string>(localStorage.getItem('countryCode') || '+1');
  countryCode$ = this.countryCodeSubject.asObservable();

  private pageReadySubject = new Subject<void>();
  pageReady$ = this.pageReadySubject.asObservable();

  private dialogStateSubject = new Subject<boolean>();
  dialogState$ = this.dialogStateSubject.asObservable();

  setDialogState(isOpen: boolean) {
    this.dialogStateSubject.next(isOpen);
  }

  signalPageReady() {
    this.pageReadySubject.next();
  }

  constructor(private http: HttpClient) { }

  updateData(data: any) {
    this.dataSubject.next(data);
  }

  refreshData(data: any) {
    this.refreshdataSubject.next(data);
  }

  refreshData1(data: any) {
    this.refreshdataSubject1.next(data);
  }

  updateCountryCode(code: string) {
    if (code) {
      this.countryCodeSubject.next(code);
      localStorage.setItem('countryCode', code);
    }
  }

  fetchCountryCode() {
    this.http.get<any>('https://ipapi.co/json/').subscribe(
      (response) => {
        if (response && response.country_calling_code) {
          this.updateCountryCode(response.country_calling_code);
        } else if (response && response.country_code) {
          // You might want to map country_code (IN) to dial_code (+91) here
          this.updateCountryCode(response.country_code);
        }
      },
      (error) => {
        console.error('Error fetching country code in shared service:', error);
      }
    );
  }

  getCountryCodeSync(): string {
    return this.countryCodeSubject.getValue();
  }
}
